import { getCurrentAppByHostname } from '../Helpers';

export const setNewVersionAvailable = (): void => {
  localStorage.setItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.NewVersionAvailable`,
    'New Version'
  );
};

export const setNewVersionUpdated = (): void => {
  localStorage.setItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.NewVersionUpdated`,
    'true'
  );
};

export const removeNewVersionAvailable = (): void => {
  localStorage.removeItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.NewVersionAvailable`
  );
};

export const removeNewVersionUpdated = (): void => {
  localStorage.removeItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.NewVersionUpdated`
  );
};

export const isNewVersionAvailable = (): boolean => {
  return (
    localStorage.getItem(
      `Smartforce.${
        getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
      }.NewVersionAvailable`
    ) !== null
  );
};

export const isNewVersionUpdated = (): boolean => {
  return (
    localStorage.getItem(
      `Smartforce.${
        getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
      }.NewVersionUpdated`
    ) !== null
  );
};
